import SweepOptionType from './schema/SweepOptionType';
import { createStore } from 'satcheljs';
var defaultSweepStore = {
    sweepDestinationFolderId: null,
    isSweepDialogShown: false,
    sweepOptionType: SweepOptionType.All,
    sweepRequestStatus: 0 /* NotInitiated */,
};
export default createStore('sweepStore', defaultSweepStore)();
//# sourceMappingURL=store.js.map